module.exports = __webpack_public_path__ + "media/images/file-icons/128/007-folder-9017e3af02a22a6d8b4d19eb4071df96.png";